<template>
    <div>
        <main class="main-wrapper flex-grow-1 with-footer">
            <div class="d-flex align-items-center bg-white">
                <div v-if="type === 'formal-evolution'"
                    class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex align-items-center justify-content-center">
                    {{ $t("1230") }}
                </div>
                <div v-else-if="type === 'regular-evolution'"
                    class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex align-items-center justify-content-center">
                    {{ $t("1231") }}
                </div>
                <div v-else
                    class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex align-items-center justify-content-center">
                    {{ $t("1232") }}
                </div>
                <div class="mgr-24 right-button">
                    <button class="mdc-button mdc-dialog__button" data-mdc-dialog-action="discard" tabindex="0"
                        type="button" @click.prevent="closeExamTake">
                        <div class="mdc-button__ripple"></div>
                        <span class="mdc-button__label t-color-iconActive font-r">{{
                            $t("3311")
                        }}</span>
                    </button>
                </div>
            </div>
            <div class="divider"></div>
            <question-navi :currentQuestion="currentQuestion" :questionSequence="questionSequence" :solves="solves"
                @selectQuestionNavi="selectQuestionNavi"></question-navi>
            <component :is="currentQuestion.type.value" v-if="currentQuestion" :key="currentQuestion.id" ref="questionComp"
                :currentQuestionCheckStatus="currentQuestionCheckStatus" :groupQuestionCount="currentGroupQuestionCount"
                :groupQuestionTitle="currentGroupQuestionTitle" :paperLevel="paperLevel" :question="currentQuestion"
                :setedAnswer="answers[currentQuestion.id]" @checkCurrentQuestionStatus="checkCurrentQuestionStatus"
                @checkIsCheckeds="checkIsCheckeds" @setAnswers="setAnswers">
            </component>
        </main>

        <div class="footer bg-white bottomStack">
            <div class="divider"></div>
            <div class="container container--narrow pdb-0">
                <div class="d-flex align-items-center justify-content-between pdt-9 pdb-10">
                    <div class="d-flex align-items-center">
                        <button v-if="showBtnPrev()" class="mdc-button bg-secondary t-color-secondaryBtnText" tabindex="0"
                            @click="previous()">
                            <div class="mdc-button__ripple"></div>
                            <i aria-hidden="true" class="material-icons mdc-button__icon">chevron_left</i>
                            <span class="mdc-button__label t-body2 font-r">{{
                                $t("1245")
                            }}</span>
                        </button>
                    </div>
                    <question-timer v-if="paperUseTimeout" :time="paperTimeout" @timerEnd="timerSubmit"
                        @timerState="timerState"></question-timer>
                    <div class="d-flex align-items-center w-120 justify-content-end">
                        <div class="text-right">
                            <div v-if="this.paper.length === this.currentGroupIndex + 1 &&
                                flag === false &&
                                currentIsCheckedButton === false
                                ">
                                <button v-if="flag === false && currentIsCheckedButton === false"
                                    :disabled="!currentQuestionSolvedStatus" class="mdc-button mdc-button--raised"
                                    tabindex="0" @click="check()">
                                    {{ $t("3066") }}
                                </button>
                            </div>
                            <div v-else>
                                <div v-if="this.paper.length === this.currentGroupIndex + 1">
                                    <button v-if="showBtnCheck() && !currentIsCheckedButton" :class="!currentQuestionSolvedStatus
                                        ? 't-color-mainBtnText disabled'
                                        : 'bg-mainBtn t-color-mainBtnText'
                                        " :disabled="!currentQuestionSolvedStatus"
                                        class="mdc-button mdc-button--raised" tabindex="0" @click="check()">
                                        {{ $t("3066") }}
                                    </button>
                                    <button v-else ref="btnSubmit"
                                        class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4"
                                        tabindex="0" @click="submit()">
                                        {{ $t("50014") }}
                                    </button>
                                </div>
                                <div v-else>
                                    <button v-if="showBtnCheck() && !currentIsCheckedButton" :class="!currentQuestionSolvedStatus
                                        ? 't-color-mainBtnText disabled'
                                        : 'bg-mainBtn t-color-mainBtnText'
                                        " :disabled="!currentQuestionSolvedStatus"
                                        class="mdc-button mdc-button--raised" @click="check()">
                                        {{ $t("3066") }}
                                    </button>
                                </div>
                                <div v-if="this.paper.length === this.currentGroupIndex + 1">
                                    <button v-if="showBtnNext()" class="mdc-button btn-white t-color-secondaryBtnText"
                                        tabindex="0" @click="next()">
                                        {{ $t("1246") }}
                                        <!-- NEXT -->
                                        <i class="material-icons mdc-button__icon">keyboard_arrow_right</i>
                                    </button>
                                </div>
                                <div v-else>
                                    <button v-if="showBtnNext() || currentIsCheckedButton"
                                        class="mdc-button btn-white t-color-secondaryBtnText" tabindex="0" @click="next()">
                                        {{ $t("1246") }}
                                        <i class="material-icons mdc-button__icon">keyboard_arrow_right</i>
                                    </button>
                                </div>
                                <button v-if="showBtnSubmit() && !flag"
                                    class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText" tabindex="0"
                                    @click="submit()">
                                    {{ $t("50014") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 시험 응시 컴포넌트(exam take component)
 * @author minkyoung.park@emcast.com
 */
// Components/Mixin/Extend/API define
import microExamApi from "@/api/microExamApi";
import QuestionNavi from "./QuestionNavi.vue";
import Timer from "./question/Timer.vue";
import { MDCRipple } from "@material/ripple";
import { microExamMixin } from "@/mixins/microExam";
import microLearnApi from "@/api/microLearnApi";

export default {
    data() {
        return {
            examTitle: "",
            currentQuestion: null,
            paperTimeout: false,
            paperUseTimeout: 0,
            paperLevel: "",
            window: null,
            paper: [],
            answers: {},
            solves: [],
            questionSequence: "",
            questionGroup: null,

            currentGroupIndex: 0,
            currentQuestionIndex: 0,
            currentGroupQuestionCount: 0,
            currentQuestionCheckStatus: false,
            currentQuestionSolvedStatus: false,

            timerPauseState: false,
            type: null,
            currentIsCheckedButton: false,
            answerTrueOrFalse: true,
            flag: false,
            fillinRange: "",
        };
    },

    mixins: [microExamMixin],

    components: {
        "question-navi": QuestionNavi,
        "question-timer": Timer,
        SHORT_ANSWER: () => import("./question/ShortAnswer.vue"),
        CHOICE_SINGLE: () => import("./question/ChoiceSingle.vue"),
        TRUE_OR_FALSE: () => import("./question/TrueandFalse.vue"),
        CHOICE_MULTIPLE: () => import("./question/ChoiceMultiple.vue"),
        FILL_IN_THE_RANGE: () => import("./question/FillInTheRange.vue"),
        FILL_IN_THE_BLANK: () => import("./question/FillInTheBlank.vue"),
        ESSAY: () => import("./question/Essay.vue"),
    },

    watch: {
        solves(newVar, oldVar) {
            let solvesIndex1 = this.solves.findIndex(
                (element) => element.questionId === this.currentQuestion.id
            );
            this.currentIsCheckedButton = this.solves[solvesIndex1].isCheckButton;
        },
    },

    mounted() {
        this.type = this.$route.query.type;
        this.setExamPaper();
        this.setMaterialUi();
    },

    methods: {
        // set paper data
        setExamPaper() {
            const params = {
                examineeId: this.$route.params.examineeId,
            };
            // set exam start
            microExamApi
                .start(params)
                .then((response) => {
                    return microExamApi.window(params);
                })
                .then((response) => {
                    this.window = response.data.data;
                    this.paperTimeout = this.window.timeout;
                    this.paperUseTimeout = this.window.useTimeout;
                    this.questionSequence = this.window.questionSequence.value;
                    this.paperLevel = this.window.level ? this.window.level.text : "";
                    this.examTitle = this.window.name;

                    // get exam question & set data
                    microExamApi.groups(params).then((response) => {
                        this.paper = response.data.data;
                        let number = 1;
                        _.each(this.paper, (group, groupIndex) => {
                            _.each(group.questions, (question, questionIndex) => {
                                question.groupIndex = groupIndex;
                                question.questionIndex = questionIndex;
                                question.number = number++;
                                question.groupId = group.id;
                            });
                        });
                        this.setCurrentQuestion();
                        this.initAnswers();
                    });
                });
        },

        getQuestionGroup() {
            this.questionGroup = this.paper[this.currentQuestionIndex];
        },

        setCurrentQuestion() {
            this.$hideLoading();
            this.currentQuestion = null;

            this.currentQuestionSolvedStatus = false;
            this.currentQuestion =
                this.paper[this.currentGroupIndex].questions[this.currentQuestionIndex];
            this.currentGroupQuestionCount =
                this.paper[this.currentGroupIndex].questions.length;
            this.currentGroupQuestionTitle = this.paper[this.currentGroupIndex].name;

            if (
                this.answers &&
                this.answers[this.currentQuestion.id] &&
                this.answers[this.currentQuestion.id].isSolve === false
            ) {
                this.currentQuestionCheckStatus = false;
                this.currentIsCheckedButton = false;
            } else if (typeof this.answers[this.currentQuestion.id] == "undefined") {
                this.currentQuestionCheckStatus = false;
                this.currentIsCheckedButton = false;
            } else {
                let solvesIndex1 = this.solves.findIndex(
                    (element) => element.questionId === this.currentQuestion.id
                );
                let currentQuestionIsSlove = JSON.parse(
                    JSON.stringify(this.solves[solvesIndex1].isSolve)
                );
                let currentQuestionIsCheckButton = JSON.parse(
                    JSON.stringify(this.solves[solvesIndex1].isCheckButton)
                );
                if (currentQuestionIsSlove === true) {
                    this.currentQuestionCheckStatus = true;
                } else {
                    if (
                        this.paper.length === this.currentGroupIndex + 1 &&
                        this.answers[this.currentQuestion.id].isSolve === true
                    ) {
                        if (currentQuestionIsCheckButton === true) {
                            this.currentQuestionCheckStatus = true;
                        } else {
                            this.currentQuestionSolvedStatus = true;
                            this.currentQuestionCheckStatus = false;
                        }
                    } else if (currentQuestionIsCheckButton === true) {
                        this.currentQuestionSolvedStatus = true;
                        this.currentQuestionCheckStatus = true;
                    } else if (this.answers[this.currentQuestion.id].isSolve === true) {
                        this.currentQuestionSolvedStatus = true;
                        this.currentQuestionCheckStatus = false;
                    } else {
                        this.currentQuestionCheckStatus = false;
                    }
                }
            }
        },

        setCurrentQuestionPriv() {
            this.currentQuestion = null;
            this.currentQuestionSolvedStatus = false;
            this.currentQuestion =
                this.paper[this.currentGroupIndex].questions[this.currentQuestionIndex];
            this.currentGroupQuestionCount =
                this.paper[this.currentGroupIndex].questions.length;
            this.currentGroupQuestionTitle = this.paper[this.currentGroupIndex].name;
            if (
                this.answers &&
                this.answers[this.currentQuestion.id] &&
                this.answers[this.currentQuestion.id].isSolve === false
            ) {
                this.currentQuestionCheckStatus = false;
            } else if (typeof this.answers[this.currentQuestion.id] == "undefined") {
                this.currentQuestionCheckStatus = false;
            } else {
                this.currentQuestionCheckStatus = true;
            }
        },

        isFirst() {
            return this.currentGroupIndex || this.currentQuestionIndex;
        },

        isGroup() {
            return this.paper[this.currentGroupIndex].questions.length > 1;
        },

        isLastGroupQuestion() {
            return (
                this.paper[this.currentGroupIndex].questions.length ===
                this.currentQuestionIndex + 1
            );
        },

        isGroupLast() {
            return this.paper.length === this.currentGroupIndex + 1;
        },

        isChecked() {
            return this.answers && this.currentQuestion
                ? this.answers[this.currentQuestion.id].checkStatus
                : false;
        },

        showBtnCheck() {
            return !this.currentQuestionCheckStatus;
        },

        showBtnNext() {
            return (
                this.currentQuestionCheckStatus &&
                (!this.isGroupLast() || !this.isLastGroupQuestion())
            );
        },

        showBtnPrev() {
            return this.isFirst();
        },

        showBtnSubmit() {
            return (
                this.currentQuestionCheckStatus &&
                this.isGroupLast() &&
                this.isLastGroupQuestion()
            );
        },

        check() {
            if (this.questionSequence === "SEQUENTIAL") {
                // is sequentially
                if (!this.answers[this.currentQuestion.id].isSolve) {
                    // 다음으로 넘어갈 수 없음(Unable to move to)
                    this.$alert({
                        title: this.$t("990"), //문항 풀이 후 다음 문항으로 이동할 수 있습니다.
                        content: this.$t("991") + this.$t("992"), //이 시험은 문항을 순차적으로 풀이해야 합니다. 문항을 풀이하고 다음 문항으로 이동해주세요.
                        accept: this.$t("993"), //확인
                    }).then(() => { });
                    return;
                }
            }
            this.currentQuestionCheckStatus = true;
            let solvesIndex1 = this.solves.findIndex(
                (element) => element.questionId == this.currentQuestion.id
            );
            this.solves[solvesIndex1].isCheckButton = true;
        },

        // move question naviagation
        selectQuestionNavi(data) {
            // // 순차 풀이 일 경우 문항 이동 불가능
            // if (this.questionSequence === 'SEQUENTIAL') {   //순차 풀이 일 경우
            //     // is sequentially
            //     // 다음으로 넘어갈 수 없음(Unable to move to)
            //     this.$alert({
            //         title: this.$t('990'),  //문항 풀이 후 다음 문항으로 이동할 수 있습니다.
            //         content: this.$t('991') + this.$t('992'),   //이 시험은 문항을 순차적으로 풀이해야 합니다. 문항을 풀이하고 다음 문항으로 이동해주세요.
            //         accept:  this.$t('993') //확인
            //     }).then(() => {})
            // } else {
            // is not sequentially
            this.currentGroupIndex = data.groupIndex;
            this.currentQuestionIndex = data.questionIndex;
            this.setCurrentQuestion();
            // }
        },

        next() {
            //this.hideCheckButton = true
            let solvesIndex = this.solves.findIndex(
                (element) => element.questionId === this.currentQuestion.id
            );
            this.solves[solvesIndex].isSolve =
                this.answers[this.currentQuestion.id].isSolve;
            this.solves.push();

            if (this.isGroup()) {
                // 그룹문항(is group)
                if (this.isLastGroupQuestion()) {
                    // is group last question
                    this.currentGroupIndex++;
                    this.currentQuestionIndex = 0;
                } else {
                    // is not group last question
                    this.currentQuestionIndex++;
                }
            } else {
                // 그룹문항(is not group)
                this.currentGroupIndex++;
                this.currentQuestionIndex = 0;
            }
            this.setCurrentQuestion();
        },

        previous() {
            if (this.isGroup()) {
                // 그룹문항(is group)
                if (!this.currentQuestionIndex) {
                    // 그룹내 마지막 문항(is group last question)
                    this.currentQuestionIndex =
                        this.paper[this.currentGroupIndex - 1].questions.length - 1;
                    this.currentGroupIndex--;
                } else {
                    // 그룹내 이전 문항(is not group last question)
                    this.currentQuestionIndex--;
                }
            } else {
                // 그룹문항 아님(is not group)
                this.currentQuestionIndex =
                    this.paper[this.currentGroupIndex - 1].questions.length - 1;
                this.currentGroupIndex--;
            }

            this.setCurrentQuestionPriv();
        },

        timerSubmit() {
            this.$alert({
                title: this.$t("1266"), //응시 시간이 종료되었습니다.
                content: this.$t("1267") + "<br>" + this.$t("1268"), //시험의 응시 시간이 모두 지났습니다. 현재까지 풀이한 문항을 제출합니다.
                accept: this.$t("1269"), //확인
            })
                .then(() => {
                    this.$router.push("/independent/exam?listType=my");
                    //this.submit()
                })
                .catch(() => { });
        },

        // 시험지 답안 제출(exam submit)
        submit() {
            this.$showLoading();
            let params = {
                examineeId: this.$route.params.examineeId,
                answers: this.answers,
            };
            this.$hideLoading();
            if (this.questionSequence === "SELECTIONAL") {
                for (var prop in this.answers) {
                    if (this.answers[prop].isSolve === false) {
                        this.answerTrueOrFalse = false;
                    }
                }
                if (this.answerTrueOrFalse === false) {
                    this.$confirm({
                        title: this.$t("3190"),
                        content: this.$t("3191") + "<br>" + this.$t("3192"),
                        accept: this.$t("3194"),
                        cancel: this.$t("3193"),
                    })
                        .then(() => {
                            this.finalSubmission(params);
                        })
                        .catch(() => { });
                } else {
                    this.finalSubmission(params);
                }
            } else {
                this.finalSubmission(params);
            }
        },

        finalSubmission(params) {
            this.$showLoading();
            microExamApi
                .submit(params)
                .then((response) => {
                    this.$hideLoading();
                    let submitResult = response.data.data;
                    let alertData = {};
                    if (submitResult.exposure) {
                        // 결과보기 가능(Available to view results)
                        alertData = {
                            title: "",
                            content: this.$t("50015"), //'TODO-제출이 완료되었습니다. 성적조회가 가능합니다. 성적을 조회하시겠습니까?',
                            accept: this.$t("50017"), //'TODO-확인',
                            cancel: this.$t("50018"), //'TODO-취소'
                        };

                        microLearnApi
                            .learnViewExams({ learnId: this.$route.params.learnId })
                            .then((response) => {
                                this.$hideLoading();
                                let paperData = response.data.data;
                                let periodPolicy = paperData.period;

                                this.$confirm(alertData)
                                    .then(() => {
                                        if (periodPolicy && periodPolicy.scoreConfirm) {
                                            this.moveExamResult();
                                        } else {
                                            this.$router.push(
                                                `/micro/${this.$route.params.learnId}?status=LEARNING`
                                            );
                                        }
                                    })
                                    .catch(() => {
                                        this.$hideLoading();
                                        this.routerGoPrev();
                                    });
                            });
                    } else {
                        // 결과보기 불가능(Unable to see results)
                        this.$showLoading();
                        microLearnApi
                            .learnViewExams({ learnId: this.$route.params.learnId })
                            .then((response) => {
                                this.$hideLoading();
                                let paperData = response.data.data;
                                let periodPolicy = paperData.period;

                                alertData = {
                                    title: "",
                                    content: this.$t("50016"), //'TODO-제출이 완료되었습니다. 결과는 성적 조회기간에 가능합니다.',
                                    accept: this.$t("50017"), //'TODO-확인',
                                    cancel: this.$t("50018"), //'TODO-취소'
                                };
                                this.$alert(alertData)
                                    .then(() => {
                                        if (
                                            periodPolicy &&
                                            periodPolicy.scoreConfirm &&
                                            periodPolicy.scoreConfirm.start <= Date.now() &&
                                            Date.now() <= periodPolicy.scoreConfirm.end
                                        ) {
                                            this.moveExamResult();
                                        } else {
                                            this.$router.push(
                                                `/micro/${this.$route.params.learnId}?status=LEARNING`
                                            );
                                        }
                                    })
                                    .catch(() => {
                                        this.$hideLoading();
                                    });
                            });
                    }
                })
                .catch((err) => {
                    this.$hideLoading();
                    let responseData = err.response.data.meta;
                    let alertMessage = this.$t("50019"); //'TODO-시험지 제출 중 오류가 발생하였습니다. 다시 응시해 주시기 바랍니다.'
                    if (responseData.errCode === "2201") {
                        alertMessage = this.$t("50020"); // this.$t('TODO-이미 재출한 시험지 입니다.')
                    }
                    this.$alert({ content: alertMessage, accept: this.$t("50021") })
                        .then(() => { })
                        .then(() => { })
                        .catch(() => { });
                });
        },

        checkCurrentQuestionStatus() {
            this.currentQuestionCheckStatus = false;
        },

        // 답안지 설정(Set Answer Paper)
        setAnswers(answer) {
            this.answers[answer.questionId] = {
                text: answer.text,
                selected: answer.selected,
                texts: answer.texts,
                startDate: answer.startDate,
                solveTime: answer.solveTime,
                isSolve: answer.isSolve,
                // checkStatus: false
            };

            //상단 문항 풀이 상태 네비게이션 설정위한 값 설정
            let solvesIndex = _.findIndex(this.solves, {
                questionId: answer.questionId,
            });

            if (
                this.paper.length === this.currentGroupIndex + 1 &&
                this.answers[answer.questionId].isSolve === true
            ) {
                this.flag = true;
            }
            this.solves[solvesIndex].isSolve = false;
            this.solves.push();
            if (answer.isSolve) {
                this.currentQuestionSolvedStatus = true;
            } else {
                this.currentQuestionSolvedStatus = false;
            }
        },

        checkIsCheckeds(answer) {
            let solvesIndex = _.findIndex(this.solves, {
                questionId: answer.questionId,
            });
            this.solves[solvesIndex].isCheckButton = false;
            if (this.paper.length === this.currentGroupIndex + 1) {
                this.fillinRange = this.solves[solvesIndex].text;
            } else {
                this.fillinRange = "";
            }
        },

        // 답안지 초기 설정(Initialize Answer Paper)
        initAnswers() {
            let questionsData = _.chain(this.paper)
                .map(function (item) {
                    return item.questions;
                })
                .flatten()
                .map(function (question, index) {
                    return question;
                })
                .value();

            // 문항 유형에 따라 답안지 설정(Set the answer sheet according to the question type)
            _.each(questionsData, (question) => {
                this.answers[question.id] = {
                    text: "",
                    selected: _(question.choices.length).times(() => {
                        return false;
                    }),
                    texts: question.blank
                        ? _(question.blank.items.length).times(() => {
                            return "";
                        })
                        : [],
                    isSolve: false,
                };
                this.solves.push({
                    questionId: question.id,
                    isSolve: false,
                    isCheckButton: false,
                    groupIndex: question.groupIndex,
                    questionIndex: question.questionIndex,
                });
            });
        },

        // 시험 종료 팝업(exam close popup)
        closeExamTake() {
            this.$confirm({
                title: this.$t("985"), //시험을 종료하시겠습니까?
                content: this.$t("986") + "<br>" + this.$t("987"), //시험 종료 시 현재까지 풀이한 문항은 제출되지 않습니다. 확인을 누르면 시험이 종료됩니다.
                accept: this.$t("989"), //확인
                cancel: this.$t("988"), //취소
            })
                .then((response) => {
                    this.routerGoPrev();
                })
                .catch((err) => {
                    console.log("err=>", err);
                });
        },

        timerState(state) {
            this.timerPauseState = state;
        },

        setMaterialUi() {
            const buttonRipple = [].map.call(
                document.querySelectorAll(".mdc-button"),
                function (el) {
                    let button = new MDCRipple.attachTo(el);
                    return button;
                }
            );
        },
    },
};
</script>
<style scoped>
.t-subtitle5 .MathJax span {
    font-family: "Roboto", "Noto Sans", "Noto Sans KR", "KhmerOS_sys", sans-serif !important;
    font-style: normal !important;
}

.w-120 {
    width: 130px !important;
}
</style>
